import CloudStoreLogo from '@svgs/logo.svg'
import Localization from "@localization/Index"
import Container from "react-bootstrap/esm/Container"
import { useNavigate } from "react-router-dom"
import { LinkContainer } from 'react-router-bootstrap'
import { useMobileMediaQuery } from '@utils/MediaComponents'


const AccessDenied = ()=>{
    const navigate = useNavigate()
    const isMobile = useMobileMediaQuery()

    if(isMobile) {
        return <>
        <div className="col-md-13">
            <Container fluid className="col-mt text-center">
                <h1 className='text-center'>
                    <LinkContainer to="/">
                        <a href="/">
                            <img className='cy-logo' src={CloudStoreLogo} width="100%" alt="logo" />
                        </a>
                    </LinkContainer>
                </h1>
                <i className="bi-x-circle-fill text-danger mt-field" style={{fontSize: '196px'}} />
                <h1 className="fs-1">{Localization.PAGE_ACCESS_DENIED.TITLE}</h1>
                <div className='fs-4 mb-5'>{Localization.PAGE_ACCESS_DENIED.SUBTITLE}</div>
                <div className="mt-field">
                    <button type="button" onClick={()=>  navigate(`/`)} className='col-md-5 justify-content-center btn btn-primary'>{Localization.PAGE_ACCESS_DENIED.BACK_TO_HOME}</button>
                </div>
            </Container>
        </div>
        </>
    }

    return <>
    <div className="col-md-13 position-absolute top-50 start-50 translate-middle">
        <Container fluid className="col-mt text-center">
            <h1 className='text-center'>
                <LinkContainer to="/">
                    <a href="/">
                        <img className='cy-logo' src={CloudStoreLogo} width="400" alt="logo" />
                    </a>
                </LinkContainer>
            </h1>
            <i className="bi-x-circle-fill text-danger mt-field" style={{fontSize: '128px'}} />
            <h1 className="mb-2 fs-1">{Localization.PAGE_ACCESS_DENIED.TITLE}</h1>
            <div>
                <small>{Localization.PAGE_ACCESS_DENIED.SUBTITLE}</small>
            </div>
            <div className="mt-field">
                <button type="button" onClick={()=>  navigate(`/`)} className='col-md-5 justify-content-center btn btn-primary'>{Localization.PAGE_ACCESS_DENIED.BACK_TO_HOME}</button>
            </div>
        </Container>
    </div>
    </>
}

export default AccessDenied